import { render, staticRenderFns } from "./ConversationRecordList.vue?vue&type=template&id=0460cae8&scoped=true&"
import script from "./ConversationRecordList.vue?vue&type=script&lang=js&"
export * from "./ConversationRecordList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0460cae8",
  null
  
)

export default component.exports